import { useMemo, useState } from 'react';

import { SingleSelectOption } from '@/modules/common';
import { useCurrencies } from '@/modules/common/hooks';

/**
 * Lazily loads supported currencies — the fetch is deferred until the user
 * opens the currency dropdown for the first time.
 */
export function useCurrencyOptions() {
  const [currenciesEnabled, setCurrenciesEnabled] = useState(false);
  const { currencies, isLoadingCurrencies } = useCurrencies({ enabled: currenciesEnabled });

  const currencyOptions: SingleSelectOption[] = useMemo(
    () =>
      currencies.map(currency => ({
        value: currency.code,
        label: currency.code,
      })),
    [currencies]
  );

  function handleCurrencyDropdownOpen(open: boolean) {
    if (open && !currenciesEnabled) {
      setCurrenciesEnabled(true);
    }
  }

  return { currencyOptions, isLoadingCurrencies, handleCurrencyDropdownOpen };
}
